import { alertConstants } from '../_constants';

export const alertActions = {
    hide,
    success,
    error,
    warning,
    info // Jeino
};

function hide(variant) {
    return { type: alertConstants.HIDE, variant };
}

function success(message) {
    return { type: alertConstants.SUCCESS, message };
}

function error(message) {
    return { type: alertConstants.ERROR, message };
}

function warning(message) {
    return { type: alertConstants.WARNING, message };
}

// Jeino
function info(message, hideDuration) {
    return { type: alertConstants.INFO, message, hideDuration };
}